var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_vm.faq.carregando ? _c('v-progress-circular', {
    staticClass: "d-flex mx-auto mt-6",
    attrs: {
      "indeterminate": "",
      "color": "primary"
    }
  }) : _vm._e(), !_vm.faq.carregando && _vm.faq.erro ? _c('v-alert', {
    staticClass: "text-center",
    attrs: {
      "type": "error",
      "text": "",
      "icon": false
    }
  }, [_c('div', {
    staticClass: "mb-2"
  }, [_vm._v("Não foi possível carregar as perguntas.")]), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.carregar
    }
  }, [_vm._v(" Tentar novamente ")])], 1) : _vm._e(), !_vm.faq.carregando && !_vm.faq.erro && _vm.faq.todas.length == 0 ? _c('div', {
    staticClass: "text-center text--secondary"
  }, [_vm._v(" Nenhuma pergunta encontrada ")]) : _vm._e(), _vm._l(_vm.faq.todas, function (faqsCategoria) {
    return _c('div', {
      key: faqsCategoria.categoria
    }, [faqsCategoria.categoria ? _c('h2', {
      staticClass: "mb-2 text-center text-body-1 font-weight-bold"
    }, [_vm._v(" " + _vm._s(faqsCategoria.categoria) + " ")]) : _vm._e(), _c('v-expansion-panels', {
      staticClass: "mb-6",
      attrs: {
        "accordion": ""
      }
    }, _vm._l(faqsCategoria.faqs, function (faq) {
      return _c('v-expansion-panel', {
        key: faq.id,
        staticClass: "my-1 faq pa-0"
      }, [_c('v-expansion-panel-header', [_c('span', {
        staticClass: "pergunta-faq",
        domProps: {
          "innerHTML": _vm._s(faq.pergunta)
        }
      })]), _c('v-expansion-panel-content', [_c('span', {
        staticClass: "resposta",
        domProps: {
          "innerHTML": _vm._s(faq.resposta)
        }
      })])], 1);
    }), 1)], 1);
  })], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };